interface ProfileArticleTagsProps {
  tags: string[]
}

function ProfileArticleTags({ tags }: ProfileArticleTagsProps) {
  if (!tags.length) return null

  const visibleTags = tags.slice(0, 2)
  const remaining = tags.length - 2

  return (
    <div className='flex w-full flex-wrap items-start gap-2 max-w-[290px] min-h-[24px] h-[24px]'>
      {visibleTags.map((tag, idx) => (
        <div
          key={`tag-${idx}`}
          className='flex h-[24px] px-[6px] py-[2px] items-center gap-1 rounded-[10px] bg-[#EBF3FF]'
        >
          <p className='text-center text-xs font-medium text-[#020251]'>
            {tag}
          </p>
        </div>
      ))}
      {remaining > 0 && (
        <div className='flex h-[24px] px-[6px] py-[2px] items-center gap-1 rounded-[10px] bg-[#EBF3FF]'>
          <p className='text-center text-xs font-medium text-[#020251]'>
            +{remaining} more
          </p>
        </div>
      )}
    </div>
  )
}

export default ProfileArticleTags
